import { api } from '@goaltree/backend/convex/_generated/api'
import type { Id } from '@goaltree/backend/convex/_generated/dataModel'
import { useMutation } from 'convex/react'

import { patchNode } from '@/lib/nodes-optimistic'

export function useRenameNode(_opts?: { parentId?: Id<'nodes'> | null }) {
  const rename = useMutation(api.nodes.rename).withOptimisticUpdate(
    (localStore, { nodeId, title }) => {
      if (title.trim()) patchNode(localStore, nodeId, { title: title.trim() })
    },
  )
  return (nodeId: Id<'nodes'>, title: string) => rename({ nodeId, title })
}
